<button (click)="showDialog($event)" *ngIf="user" [matBadge]="unreadConversationsCount ? unreadConversationsCount : ''" aria-label="Show messages"
        class="header-round-button" i18n-aria-label="Show messages" mat-icon-button matBadgeColor="warn" matBadgePosition="after">
  <mat-icon color="accent">message</mat-icon>
</button>
